export const isJSON = x => {
    try {
        JSON.parse(x)
        return true
    } catch (parseException) {
        return false
    }
}
